import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteEvents = () => {
    const [events, setEvents] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedEvents();
    }, []);

    const fetchDeletedEvents = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/events/deleted');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setEvents(data);
        } catch (error) {
            console.error('Error fetching deleted events:', error);
        }
    };

    const handleRestore = async (eventId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this event?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/events/restore/${eventId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setEvents(events.filter(event => event.id !== eventId));
                        Swal.fire({
                            title: "Restored!",
                            text: "The event has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore event');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the event.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring event:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the event.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (eventId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone. The event will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/events/delete/permanent/${eventId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        setEvents(events.filter(event => event.id !== eventId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The event has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete event permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the event.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting event permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the event.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter events based on search term
    const filteredEvents = events.filter(event => 
        (event.eventName && event.eventName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.university && event.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.venue && event.venue.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE EVENTS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Event Name</th>
                                    <th>University Name</th>
                                    <th>Venue</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEvents.map((eventItem) => (
                                    <tr key={eventItem.id}>
                                        <td>{eventItem.eventName}</td>
                                        <td>{eventItem.university}</td>
                                        <td>{eventItem.venue}</td>
                                        <td>{new Date(eventItem.date).toLocaleDateString('en-CA')}</td>
                                        <td>{eventItem.time}</td>
                                        <td><a href={eventItem.link} target="_blank" rel="noopener noreferrer" id='view-website'>Link</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(eventItem.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(eventItem.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteEvents;
